module.exports = __webpack_public_path__ + "img/panelIzquierdo.258a8f0a.png";